import { InAppReview } from '@capacitor-community/in-app-review';
import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { useEffect, useMemo, useState } from 'react';
import { capacitorService } from '../../../../../application/CapacitorService';
import { LoaderPage } from '../../../../../components/LoaderPage';
import { Route } from '../../../../../domain/route/Route';
import { useCreateSurvey } from '../../hooks/useCreateSurvey';
import { useUpdateSurvey } from '../../hooks/useUpdateSurvey';
import { RouteSurveyComments } from './RouteSurveyComments';
import { RouteSurveyStars } from './RouteSurveyStars';
import { RouteSurveyThanks } from './RouteSurveyThanks';

type RouteSurveyProps = {
  route: Route;
};

export const RouteSurvey = ({ route }: RouteSurveyProps) => {
  const { run: createSurvey, isLoading, error, success } = useCreateSurvey(route);
  const [isCretingSurvey, setIsCreatingSurvey] = useState(false);
  const { isLoading: updateSurveyIsLoading, run: updateSurvey } = useUpdateSurvey(route);

  const showRatingStars = useMemo(() => route.survey?.rating === undefined, [route.survey]);
  const showComments = useMemo(() => route.survey?.comments === undefined, [route.survey]);

  useEffect(() => {
    setIsCreatingSurvey(false);
  }, [error, success]);

  return (
    <Grid
      container
      style={{ padding: `20px`, borderRadius: `10px`, border: `1px solid ${RoutalPalette.neutral10}`, height: `228px` }}
      justifyContent="center"
      direction="column"
      alignItems="center"
    >
      {updateSurveyIsLoading ? (
        <LoaderPage />
      ) : showRatingStars ? (
        <RouteSurveyStars
          onSelectStar={(rating) => {
            if (!isCretingSurvey && !isLoading) createSurvey({ rating }); // These two comprobations are to avoid the double click but maintaining the animation without loader

            if (capacitorService.isNative() && rating >= 4) {
              InAppReview.requestReview();
            }
          }}
        />
      ) : showComments ? (
        <RouteSurveyComments
          isUpdating={updateSurveyIsLoading}
          onComment={(comments) => {
            updateSurvey({ comments });
          }}
        />
      ) : (
        <RouteSurveyThanks />
      )}
    </Grid>
  );
};
